import { render, staticRenderFns } from "./NavigationLink.component.vue?vue&type=template&id=002ed8a8&scoped=true"
import script from "./NavigationLink.component.vue?vue&type=script&lang=js"
export * from "./NavigationLink.component.vue?vue&type=script&lang=js"
import style0 from "./NavigationLink.component.vue?vue&type=style&index=0&id=002ed8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002ed8a8",
  null
  
)

export default component.exports